import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const randysPizzaCustomerGroup = 'randys';
export const customerGroup = randysPizzaCustomerGroup;

export const venueConfig = {
	dev: 'randys_pizza_dev',
	prod: 'rp1',
};

const supportEmail = {
	anton_and_anni: 'anton_and_anni@smoothr.de',
};
const firebaseConfig = {
	randys: {
		apiKey: 'AIzaSyChoU3w8eUGbt1YFI2bRJunKQG00rKEFT0',
		authDomain: 'anton-and-anni.firebaseapp.com',
		projectId: 'anton-and-anni',
		storageBucket: 'anton-and-anni.firebasestorage.app',
		messagingSenderId: '581541930478',
		appId: '1:581541930478:web:0b44bea6df9bc69c1e1aff',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: 'https://randy-pizza.com/allergen.pdf',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	enableCashPayment: true,
};
